export default __webpack_public_path__ + "static/3M-7ced51837adb5e9c657c0712b2475ff0.png";